// Importa solo los módulos necesarios
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import settings from "./settings";

// Inicializa la app con la configuración
const firebaseApp = initializeApp(settings);

// Obtiene la base de datos
export const db = getDatabase(firebaseApp);
export default firebaseApp;
